<form>
    <p>Income Proof :</p>
    <div class="proof-option">
        <div class="doc-upload-action">
            <div class="left-block">
                <img src="https://images.5paisa.com/SPOT/activation/bank-statement.png" />
                <div class="text">
                    <div [innerHTML]="txtContant"></div>
                    <!-- <h5>Bank Statement</h5>
                    <span>(last 6 months)</span> -->
                </div>
            </div>
            <div class="right-block">
                <input type="file" class="file-input" [accept]="accept" [hidden]="true" (change)="uploadBankStatement($event,'upload1')" #fileUpload1>
                <span class="upload-button" (click)="fileUpload1.click()">
                    <img src="https://images.5paisa.com/SPOT/activation/modification/upload.svg" />
                    Upload
                </span>
            </div>
            <div class="right-block" *ngIf="uploadProof2Show">
                <input type="file" class="file-input" [hidden]="true" (change)="uploadBankStatement($event, 'upload2')" #fileUpload2>
                <span class="upload-button" (click)="fileUpload2.click()">
                    <img src="https://images.5paisa.com/SPOT/activation/modification/upload.svg" />
                    Upload
                </span>
            </div>
        </div>
        <div _ngcontent-ttc-c65="" class="doc-upload-action"><span>
            Note : Currently we are accepting PDF only.
        </span></div>
        <mat-error>{{fileErrorMessage}}</mat-error>
        <div class="toast-bar">
            <span class="info-icon"> i </span>
            @if(display){
                <span>Kindly upload pdf file with less than 10 MB.</span>
            }@else {
                <span [innerHtml]="message"></span>
            }
        </div>
        <div class="icons-wrapper">
            <h3>Do's</h3>
            <div class="row">
                <div class="col-xs-4">
                    <div class="text-center">
                        <div class="do-icon">
                            <img src="https://images.5paisa.com/SPOT/activation/modification/bank-statement.png" />
                            <img
                                class="check-icon"
                                src="https://images.5paisa.com/SPOT/activation/modification/checkCircle.svg"
                            />
                        </div>
                        <p [innerHTML]="do_1"></p>
                    </div>
                </div>
                <div class="col-xs-4">
                    <div class="text-center">
                        <div class="do-icon">
                            <img src="https://images.5paisa.com/SPOT/activation/modification/clear-image.png" />
                            <img
                                class="check-icon"
                                src="https://images.5paisa.com/SPOT/activation/modification/checkCircle.svg"
                            />
                        </div>
                        <p>Clear image</p>
                    </div>
                </div>
                <div class="col-xs-4">
                    <div class="text-center">
                        <div class="do-icon">
                            <img src="https://images.5paisa.com/SPOT/activation/modification/full-scan.png" />
                            <img
                                class="check-icon"
                                src="https://images.5paisa.com/SPOT/activation/modification/checkCircle.svg"
                            />
                        </div>
                        <p>Full scan copy (Bank statement/ Passbook/ Cheque)</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="dont-icons-wrapper">
            <h3>Dont's</h3>
            <div class="row">
                <div class="col-xs-4">
                    <div class="text-center">
                        <div class="dont-icon">
                            <img src="https://images.5paisa.com/SPOT/activation/modification/mobile-screenshot.png" />
                            <img
                                class="check-icon"
                                src="https://images.5paisa.com/SPOT/activation/modification/fail.svg"
                            />
                        </div>
                        <p>Mobile screenshots</p>
                    </div>
                </div>
                <div class="col-xs-4">
                    <div class="text-center">
                        <div class="do-icon">
                            <img src="https://images.5paisa.com/SPOT/activation/modification/driving-license.png" />
                            <img
                                class="check-icon"
                                src="https://images.5paisa.com/SPOT/activation/modification/fail.svg"
                            />
                        </div>
                        <p>Clear image</p>
                    </div>
                </div>
                <div class="col-xs-4">
                    <div class="text-center">
                        <div class="do-icon">
                            <img src="https://images.5paisa.com/SPOT/activation/modification/blank-document.png" />
                            <img
                                class="check-icon"
                                src="https://images.5paisa.com/SPOT/activation/modification/fail.svg"
                            />
                        </div>
                        <p>Full scan copy (Bank statement/ Passbook/ Cheque)</p>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</form>